import * as React from 'react'
import './summary-table.css'
import { withStatus } from '../modules/status'


interface TableProps{
    split60x40?:boolean
    riskItemTable?:boolean
    alternate?:boolean
}


export class Table extends React.Component<TableProps, {}>{
    render(){
        return <div className="col-12"><div className={`summary-table ${ this.props.alternate ? "summary-table-alternate" : null } ${ this.props.split60x40 ? "split-60-40" : ""} ${ this.props.riskItemTable ? "riskItemTable" : ""}`}>{ this.props.children }</div></div>
    }
}


export class Alternate extends React.Component<{}, {}>{
    render(){
        return <div className="summary-table-alternate">{ this.props.children }</div>
    }
}


interface RowProps{
    asHeading?:boolean,
    noClearfix?:boolean,
    show?: boolean,
    highlight?:boolean
}

export class Row extends React.Component<RowProps, {}>{
    render(){
        const asHeading = this.props.asHeading;
        const noClearfix = this.props.noClearfix;
        const highlight = this.props.highlight;
        const show = this.props.show;

        if(show == null || show){
            return <div className={`summary-table-row ${highlight ? "summary-table-highlight" : ""} ${asHeading ? "summary-table-heading" : ""} ${noClearfix ? "no-clearfix" : ""} `}>{ this.props.children }</div> 
        }else{
            return null
        }
    }
}



@withStatus
export class Cell extends React.Component<any, any>{
    
    showHelp(){
        const help = <div dangerouslySetInnerHTML={{ __html:this.props.help }}></div>
        this.props.actions.status.showMessage(null, help, null);
    }
    
    render(){
        const show = this.props.show;
        
        if(show == null || show){
            return (
                <div className={`summary-table-cell ${this.props.className}`}>
                    { this.props.children } {this.props.help ? <i className="fa fa-question-circle-o help-icon" aria-hidden="true" onClick={ this.showHelp.bind(this) }/> : null }
                </div>
            )
        }else{
            return null
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/summary-table.tsx